// Central content/config for the Polar Vortex (PVEI Home Services) site.
// Keeping this data-driven makes it trivial to update copy without touching layout code.

export const SITE_URL = "https://pvei.org";

export const business = {
  name: "Polar Vortex",
  legalName: "Polar Vortex Home Services",
  shortName: "Polar Vortex",
  tagline: "The Trusted Handyman",
  phoneDisplay: "(727) 639-7070",
  phoneHref: "tel:+17276397070",
  email: "info@pvei.org",
  emailHref: "mailto:info@pvei.org?subject=Website%20Contact",
  license: "CGC1517808",
  serviceArea: "Tampa Bay & Pasco County, Florida",
  hours: "Mon \u2013 Sat: 7:00 AM \u2013 6:00 PM",
  yearsExperience: "25+",
};

export const nav = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/general-contractor-services" },
  { label: "Our Services", path: "/handyman-services-in-pasco" },
  { label: "Contact Us", path: "/contact-pvei-home-services" },
];

// Home page — "Our Pasco Home Repair & Contractor Services" numbered list
export const numberedServices = [
  {
    number: "01",
    title: "General Repairs and Remodels",
    text: "From your foundation to your drywall, we can help you overcome any repair your home may need.",
  },
  {
    number: "02",
    title: "Kitchen Renovations",
    text: "We are contractors who specialize in altering the structure of an existing space, we take your ideas and bring them to life.",
  },
  {
    number: "03",
    title: "Window and Door Replacement",
    text: "Licensed & bonded service professionals who will either repair or replace the broken system at no further cost.",
  },
  {
    number: "04",
    title: "Plumbing",
    text: "Installation and repairs \u2014 we repair, maintain, and install pipe systems, water heaters, bathtubs, toilets, drains, showers and much more.",
  },
  {
    number: "05",
    title: "Bathroom Remodels",
    text: "Installation and repairs \u2014 upgrade your space to make it more energy efficient and secure.",
  },
  {
    number: "06",
    title: "Flooring",
    text: "Installation and repair, from your trusted local pros.",
  },
];

// Services page — "OUR SERVICES / Home Improvement Solutions"
export const services = [
  {
    icon: "ChefHat",
    title: "Kitchens",
    text: "Cabinetry, tile, caulk & grout, backsplash, flooring, updates & full remodels, and miscellaneous repairs.",
  },
  {
    icon: "DoorOpen",
    title: "Window and Door",
    text: "Add curb appeal and help cut utility costs without spending a fortune \u2014 partial or full installations, caulk & seal.",
  },
  {
    icon: "TreePine",
    title: "Outdoor Living",
    text: "Siding, outdoor kitchens, concrete, masonry, exterior paint, stucco, roofing, lighting, security, porches & decks.",
  },
  {
    icon: "Bath",
    title: "Bathrooms",
    text: "Updating, plumbing repairs, flooring, tile, grout, caulk, vanities, lighting, mirrors, closets, tubs & showers.",
  },
  {
    icon: "Droplets",
    title: "Plumbing",
    text: "Toilets, tubs, sinks \u2014 new installs & repairs, septic, updating & re-routing.",
  },
  {
    icon: "ShieldCheck",
    title: "Home Security",
    text: "Entry doors & locks, alarms & cameras.",
  },
  {
    icon: "Layers3",
    title: "Drywall",
    text: "New installation, removal & replacement, mold detection & removal, finishing & painting.",
  },
  {
    icon: "Grid2x2",
    title: "Flooring",
    text: "Vinyl, ceramic, hardwood, laminate, concrete \u2014 refinishing & sealing/coating, replacement & repairs, new installation.",
  },
];

// About page — grouped from the full handyman task list on the source site
export const aboutCategories = [
  {
    icon: "DoorOpen",
    title: "Doors & Entryways",
    items: [
      "Door repairs & installation",
      "Door handles & lock installs",
      "Door jamb installation",
      "Hanging doors",
      "Flyscreens for windows & doors",
      "Break-in & storm damage repairs",
      "Board-ups",
    ],
  },
  {
    icon: "Hammer",
    title: "Decking, Fencing & Carpentry",
    items: [
      "Decking & porches",
      "Extensions & renovations",
      "Fencing",
      "Carpentry work",
      "Hanging curtains & blinds",
    ],
  },
  {
    icon: "ChefHat",
    title: "Kitchen & Laundry",
    items: ["Kitchen & laundry repairs", "Cupboard door repairs"],
  },
  {
    icon: "Droplets",
    title: "Plumbing & Drainage",
    items: [
      "Blocked drains & sinks",
      "Downpipe repairs & replacement",
      "New tapware & leaking taps",
      "Tap mixer installations",
      "Leaking drain repairs",
      "Sink & toilet repairs / installation",
      "Hot water system installs",
    ],
  },
  {
    icon: "TreePine",
    title: "Outdoor & Landscaping",
    items: [
      "Gardening & landscaping",
      "Lawn mowing & mulching",
      "Paving & outdoor tiling",
      "Pressure cleaning",
      "Pruning & weeding",
      "Retaining walls",
      "Concrete driveways",
      "Tiling repairs",
    ],
  },
  {
    icon: "Lightbulb",
    title: "Electrical & Lighting",
    items: [
      "Additional power points",
      "Bulb replacement",
      "Ceiling fan installation",
      "Extractor fan install & repair",
      "Indoor, outdoor & downlight installation",
      "Safety switches",
    ],
  },
  {
    icon: "ShieldCheck",
    title: "Safety & Painting",
    items: [
      "Smoke alarm checks & installation",
      "Plaster patching (walls & ceilings)",
      "Internal & external painting",
      "Cement render crack repairs",
      "Storm damage repairs",
    ],
  },
  {
    icon: "Bath",
    title: "Bathroom Renovations",
    items: [
      "Full bathroom renovation & redesign",
      "Cement rendering walls",
      "Waterproofing",
      "Tiling & grouting",
      "Vanity installation",
      "Shower screens",
      "Bathtub installation",
    ],
  },
  {
    icon: "CloudRain",
    title: "Gutters & Roofing",
    items: [
      "Gutter cleaning & guards",
      "Gutter repair & replacement",
      "Flashing & downpipe repairs",
      "Roof painting",
      "Wood staining & varnishing",
    ],
  },
];

export const partners = [
  { name: "Shaw", src: "/assets/partners/shaw.png" },
  { name: "Mohawk", src: "/assets/partners/mohawk.png" },
  { name: "Makita", src: "/assets/partners/makita.png" },
  { name: "Shenandoah", src: "/assets/partners/shenandoah.png" },
  { name: "Moen", src: "/assets/partners/moen.png" },
];

export const trustPoints = [
  { icon: "Award", label: `License # ${business.license}` },
  { icon: "Clock", label: `${business.yearsExperience} Years Experience` },
  { icon: "ShieldCheck", label: "Fully Insured & Vetted" },
  { icon: "MapPin", label: business.serviceArea },
];
